import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import InboxMessageList from './InboxMessageList';
import type { MaterialTopTabBarProps } from '@react-navigation/material-top-tabs';
import { Route } from '@bonanza-social/navigation';
import { DARK_TOKENS } from '@bonanza-social/moonlight/lib/theme/index.content';
import { Animated, Pressable, StyleSheet } from 'react-native';
import { Box } from '@bonanza-social/moonlight';
import { Variants } from '@bonanza-social/moonlight/lib/common/Text/Text.content';

export const Tab = createMaterialTopTabNavigator();

export const AllMessagesScreen = () => <InboxMessageList type="All" />;
export const Smartico = () => <InboxMessageList type="Marketing" />;
export const Activity = () => <InboxMessageList type="Activity" />;
export const Unread = () => <InboxMessageList type="Unread" />;

type TabItemProps = MaterialTopTabBarProps & {
  route: Route<string>;
  index: number;
};

function TabItem({ route, index, state, navigation, position }: TabItemProps) {
  const isFocused = state.index === index;

  const inputRange = state.routes.map((_, i) => i);
  const isFocusedArray = state.routes.map((_, i) => i === index);

  const backgroundColor = position.interpolate({
    inputRange,
    outputRange: isFocusedArray.map((focused) =>
      focused
        ? DARK_TOKENS.primarySolidBackgroundPale
        : DARK_TOKENS.onLightTertiaryBackground,
    ),
  });

  const opacity = position.interpolate({
    inputRange,
    outputRange: isFocusedArray.map((focused) => (focused ? 1 : 0)),
  });

  const textColor = position.interpolate({
    inputRange,
    outputRange: isFocusedArray.map((focused) =>
      focused
        ? DARK_TOKENS.accentSurfacePrimary
        : DARK_TOKENS.darkSurfacePrimary,
    ),
  });

  const { fontFamily } = Variants['input-label'];

  return (
    <Pressable onPress={() => !isFocused && navigation.navigate(route.name)}>
      <Animated.View
        style={[
          {
            borderRadius: 999,
            padding: 8,
            backgroundColor,
          },
        ]}
      >
        <Animated.View style={{ ...StyleSheet.absoluteFillObject, opacity }}>
          <Box
            variant="gradient"
            gradient="accentBackground"
            width="100%"
            height="100%"
            borderRadius="radius-full"
          />
        </Animated.View>
        <Animated.Text
          style={{ fontFamily: fontFamily as string, color: textColor }}
        >
          {route.name}
        </Animated.Text>
      </Animated.View>
    </Pressable>
  );
}

export function TabBar(props: MaterialTopTabBarProps) {
  const { state } = props;
  return (
    <Box
      flexDirection="row"
      justifyContent="flex-start"
      gap="space-100"
      marginHorizontal="space-400"
    >
      {state.routes.map((route, index) => (
        <TabItem key={route.key} {...props} route={route} index={index} />
      ))}
    </Box>
  );
}
